module.exports = __webpack_public_path__ + "img/text-con-10.abc9a0c5.png";